module.exports = __webpack_public_path__ + "static/img/1066_big.31d3a8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1066_big.png
// module id = ksm7
// module chunks = 1